import { SelectFieldOptionsType } from '@/types/schema';

const getValue = (options: SelectFieldOptionsType[], multiple: boolean) => {
  if (!multiple) {
    const lastOption = options[options.length - 1];
    return lastOption ? lastOption.optionId : '';
  }

  return options.map((option) => option.optionId).join(',');
};

export default getValue;
